<ng-container>
    <div class="modal" *transloco="let t; read:'permit.subscriptions.answerModal'">
        <div class="modal__content">
            <div [innerHtml]="t('answerText' + (data.invitation.invitationType === SubscriptionInvitationType.Issuer ? 'Issuer' : 'Superintendent'), { name: data.invitation.subscriptionName })"></div>
            <div class="modal__content__heading">
                <span>{{ t("signature") }}</span>
            </div>
            <signature-pad *ngIf="signaturePadOptions" class="modal__content__signature" #signature [options]="signaturePadOptions"
                           (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>
            <div class="modal__content__details__name-and-clear">
                <div class="modal__content__details__name-and-clear__person">
                    <div class="modal__content__details__name-and-clear__person__name">
                        {{ (user$ | async).fullName }}
                    </div>
                </div>
                <button class="modal__content__details__name-and-clear__clear-button" (click)="clear()">{{ t("clear") }}</button>
            </div>
        </div>
        <div class="modal__actions">
            <button class="modal__actions__deny" type="button" (click)="deny()">{{ t("deny") }}</button>
            <button class="modal__actions__accept" type="button" [class.modal__actions__accept--disabled]="!hasSignature" (click)="accept()">{{ t("accept") }}</button>
        </div>
    </div>
</ng-container>
